export default __webpack_public_path__ + "static/media/sectores_12.8ad90ee6.png";